import api from './apiClient';
import {
  ChangePlanResponse,
  CheckoutSessionResponse,
  CurrentSubscriptionResponse,
  PlansResponse,
  PortalSessionResponse,
} from '../types/subscription.types';

export const subscriptionsApi = {
  getPlans: async (): Promise<PlansResponse> => {
    const response = await api.get<PlansResponse>('/subscriptions/plans');
    return response.data;
  },

  getCurrentSubscription: async (): Promise<CurrentSubscriptionResponse> => {
    const response = await api.get<CurrentSubscriptionResponse>('/subscriptions/current');
    return response.data;
  },

  createCheckoutSession: async (
    planId: number,
    successUrl: string,
    cancelUrl: string
  ): Promise<CheckoutSessionResponse> => {
    const response = await api.post<CheckoutSessionResponse>('/subscriptions/create-checkout-session', {
      plan_id: planId,
      success_url: successUrl,
      cancel_url: cancelUrl,
    });
    return response.data;
  },

  createPortalSession: async (returnUrl: string): Promise<PortalSessionResponse> => {
    const response = await api.post<PortalSessionResponse>('/subscriptions/create-portal-session', {
      return_url: returnUrl,
    });
    return response.data;
  },

  cancelSubscription: async () => {
    const response = await api.post('/subscriptions/cancel');
    return response.data;
  },

  reactivateSubscription: async () => {
    const response = await api.post('/subscriptions/reactivate');
    return response.data;
  },

  unsubscribe: async (reason: string, otherReasonText?: string) => {
    const response = await api.post('/subscriptions/unsubscribe', {
      reason,
      other_reason_text: otherReasonText,
    });
    return response.data;
  },

  changePlan: async (planId: number): Promise<ChangePlanResponse> => {
    const response = await api.post<ChangePlanResponse>('/subscriptions/change-plan', {
      plan_id: planId,
    });
    return response.data;
  },
};

export const topupsApi = {
  getPacks: async () => {
    const response = await api.get('/topups/packs');
    return response.data;
  },

  purchaseTopup: async (topupPackId: number, successUrl: string, cancelUrl: string) => {
    const response = await api.post('/topups/purchase', {
      topup_pack_id: topupPackId,
      success_url: successUrl,
      cancel_url: cancelUrl,
    });
    return response.data;
  },

  getPurchaseHistory: async () => {
    const response = await api.get('/topups/purchase-history');
    return response.data;
  },
};

export const userSettingsApi = {
  getFeatureFlags: async () => {
    const response = await api.get('/user-settings/feature-flags');
    return response.data;
  },
};

